<eda-dialog2 width="50vw" height="100vh" (apply)="savePermission()" [header]="title" (close)="closeDialog()" [overflow]="'auto'">

  <div content class="p-2 space-y-6">

    <!-- Permission Type Selection -->
    <div class="bg-gray-50 rounded-lg border border-gray-200">
      <div class="p-3 border-b border-gray-200">
        <h3 class="text-xl font-medium text-gray-900" i18n="@@permissionType">Tipo de Permisos</h3>
        <p class="text-base text-gray-600" i18n="@@permissionTypeDescription">Selecciona cómo quieres gestionar los permisos</p>
      </div>
      <div class="p-3 space-y-4">
        <!-- User Permissions Radio -->
        <div
          class="perm-row flex items-center space-x-3 p-3 rounded-lg border bg-white border-gray-200 transition-colors cursor-pointer"
          (click)="setPermissionType('users')">
          <input type="radio" id="user-permissions" name="permissionType" value="users" [checked]="type === 'users'"
            class="perm-radio w-4 h-4 bg-gray-100 border-gray-300">
          <label for="user-permissions" class="flex items-center gap-2 cursor-pointer flex-1">
            <svg class="h-4 w-4 text-[var(--corporate-primary)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
            </svg>
            <div>
              <div class="text-base font-medium text-gray-900" i18n="@@permissionTypeUser">Permisos por Usuario</div>
              <div class="text-sm text-gray-600" i18n="@@permissionTypeUserDescription">Asignar permisos individualmente a
                usuarios específicos</div>
            </div>
          </label>
        </div>

        <!-- Group Permissions Radio -->
        <div
          class="perm-row flex items-center space-x-3 p-3 rounded-lg border bg-white border-gray-200 transition-colors cursor-pointer"
          (click)="setPermissionType('groups')">
          <input type="radio" id="group-permissions" name="permissionType" value="groups" [checked]="type === 'groups'"
            class="perm-radio w-4 h-4 bg-gray-100 border-gray-300">
          <label for="group-permissions" class="flex items-center gap-2 cursor-pointer flex-1">
            <svg class="h-4 w-4 text-[var(--corporate-primary)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z">
              </path>
            </svg>
            <div>
              <div class="text-base font-medium text-gray-900" i18n="@@permissionTypeGroup">Permisos por Grupo</div>
              <div class="text-sm text-gray-600" i18n="@@permissionTypeGroupDescription">Asignar permisos a grupos de usuarios
              </div>
            </div>
          </label>
        </div>


        @if(type==='users'){
          <div class="col-12">
            <p-multiSelect [options]="users" [(ngModel)]="selectedUsers" [virtualScroll]="true" [itemSize]="30"
              [style]="{'vertical-align' : 'bottom', width: '100%' }" [panelStyle]="{minWidth:'15em'}"
              [maxSelectedLabels]="1" [defaultLabel]="usersDefaultLabel">
            </p-multiSelect>
          </div>
        }

        <!-- GROUPS -->
        @if(type==='groups'){
          <div class="col-12">
            <p-multiSelect [options]="roles" [(ngModel)]="selectedRoles" [virtualScroll]="true" [itemSize]="30"
              [style]="{'vertical-align' : 'bottom', width: '100%' }"
              [panelStyle]="{minWidth:'15em'}" [maxSelectedLabels]="1" [defaultLabel]="groupsDefaultLabel">
            </p-multiSelect>
          </div>
        }
        

        @if(type){
          <div class="space-y-3 mt-4">
            <p-multiSelect [options]="values" [(ngModel)]="selectedValues" [virtualScroll]="true" [itemSize]="30"
              [style]="{'vertical-align' : 'bottom', width: '100%' }" [maxSelectedLabels]="1" defaultLabel="ID"
              [disabled]="all">
            </p-multiSelect>
          </div>
        }


        <!-- SWITCHES Y DINÁMICO -->
        @if(type){
          <div class="mt-5 bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-4">

            <h3 class="text-base font-medium text-gray-700" i18n="@@AdvanceOptions">
              Opciones avanzadas
            </h3>

            <!-- Switch: Todos -->
            <div class="flex items-center justify-between bg-white border border-gray-200 rounded-lg p-3">
              <div>
                <div class="text-base font-medium text-gray-900" i18n="@@AllTags">Todos</div>
                <p class="text-sm text-gray-600" i18n="@@AllTagsDescription">
                  Acceso a todos los elementos sin restricciones
                </p>
              </div>
              <p-inputSwitch [(ngModel)]="all" (onChange)="syncronizeAllNoneValuesAll()">
              </p-inputSwitch>
            </div>

            <!-- Switch: Ninguno -->
            <div class="flex items-center justify-between bg-white border border-gray-200 rounded-lg p-3">
              <div>
                <div class="text-base font-medium text-gray-900" i18n="@@NoneTags">Ninguno</div>
                <p class="text-sm text-gray-600" i18n="@@NoneTagsDescription">
                  No se muestra ningún elemento para este usuario/grupo
                </p>
              </div>
              <p-inputSwitch [(ngModel)]="none" (onChange)="syncronizeAllNoneValuesNone()">
              </p-inputSwitch>
            </div>

            <!-- Switch: Dinámico -->
            <div class="flex items-center justify-between bg-white border border-gray-200 rounded-lg p-3">
              <div>
                <div class="text-base font-medium text-gray-900" i18n="@@DynamicTags">Dinámico</div>
                <p class="text-sm text-gray-600" i18n="@@DynamicTagsDescription">
                  Filtrado avanzado mediante una consulta personalizada
                </p>
              </div>
              <p-inputSwitch [(ngModel)]="dynamic" (onChange)="syncronizeAllNoneValuesDynamic()">
              </p-inputSwitch>
            </div>

            <!-- Input Dinámico -->
            @if(dynamic){
              <div class="mt-3">
                <label class="block text-base font-semibold text-gray-900 mb-1" i18n="@@inputConsultaDinamica">
                  Consulta dinámica
                </label>
                <input pInputText type="text" [(ngModel)]="dynamicQuery"
                  class="w-full p-2 border border-gray-300 rounded-md" i18n-placeholder="@@placeholderConsultaDinamica" placeholder="Introduzca la expresión dinámica…">
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>


</eda-dialog2>